import { TypographyProps, Typography, ButtonProps, Button, styled, BoxProps } from '@mui/material'
import * as React from 'react'

import { VBox } from './basic-elements'
import { colors } from '../constants/colors'

export const FormBox = ({
  alignItems = 'center',
  justifyContent = 'center',
  textAlign = 'center',
  width = 728,
  maxWidth = '100%',
  margin = 'auto',
  ...props
}: React.PropsWithChildren<BoxProps>) => (
  <VBox
    alignItems={alignItems}
    justifyContent={justifyContent}
    textAlign={textAlign}
    width={width}
    maxWidth={maxWidth}
    margin={margin}
    {...props}
  />
)

export const Title = (props: TypographyProps) => (
  <Typography
    variant="h3"
    color="textSecondary"
    fontFamily="Fields"
    sx={{ width: '20em', maxWidth: '100%' }}
    mb={3.75}
    {...props}
  />
)
export const Body = (props: TypographyProps) => (
  <Typography variant="body1" color="textSecondary" sx={{ maxWidth: '100%' }} {...props} />
)
export const Email = (props: TypographyProps) => (
  <Typography component="span" sx={{ textDecoration: 'underline' }} {...props} />
)

export const ButtonBox = (props: React.PropsWithChildren<BoxProps>) => (
  <VBox
    justifyContent="center"
    alignItems="center"
    mt={4}
    mx="auto"
    width={345}
    maxWidth="100%"
    {...props}
  />
)

export const ButtonPrimary = (props: ButtonProps) => (
  <Button
    fullWidth
    variant="contained"
    disableElevation
    color="tertiary"
    sx={{ py: 1.5 }}
    {...props}
  />
)

export const ButtonSecondary = (props: ButtonProps) => (
  <Button variant="text" color="info" disableTouchRipple {...props} />
)
export const ButtonWarning = (props: ButtonProps) => (
  <Button
    fullWidth
    variant="contained"
    disableElevation
    color="warning"
    sx={{ py: 1.5 }}
    {...props}
  />
)

export const TextButtonBase = (props: ButtonProps) => (
  <Button
    variant="text"
    color="info"
    disableTouchRipple
    {...props}
    sx={{
      p: 0,
      lineHeight: '1em',
      fontSize: '1em',
      textDecoration: 'underline',
      backgroundColor: 'transparent!important',
      ...(props.sx || {})
    }}
  />
)

export const TextButton = styled(TextButtonBase)`
  ${({ theme }) => `
    color: ${theme.palette.mode == 'dark' ? colors.DARK_MODE_30 : colors.GEORGIAN_BAY_70};
  `}
`

export const BaseText = (props: TypographyProps) => (
  <Typography variant="body1" fontSize={24} {...props} />
)

export const ButtonText = styled(BaseText)<{ lightColor?: string; darkColor?: string }>``

export const ErrorText = (props: TypographyProps) => (
  <Typography variant="body2" textAlign="left" color="error" {...props} />
)
